import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { FC, InputHTMLAttributes, memo, useMemo } from "react";

type InputProps = InputHTMLAttributes<HTMLInputElement>;

const Input: FC<InputProps> = (props) => {
  const { other, text } = useTheme();
  const InputComponent = useMemo(
    () => styled.input`
      border: ${other.border};
      border-radius: ${other.borderRadius};
      ${text.normalSmall};
      transition: 0.05s ease all;
      &:focus {
        outline: none;
        border: 1px solid rgb(216, 180, 254);
        box-shadow: 0 0 0 3px rgba(233, 213, 255, 0.5);
      }
      padding: 11px 20px;
      &.with-error {
        border: 1px solid red;
      }
    `,
    [other.border, other.borderRadius, text.normalSmall],
  );
  return <InputComponent {...props} />;
};

export default memo(Input);
